import React from 'react'
import { Router, Route, Switch, Redirect } from 'react-router-dom'
import { createBrowserHistory } from 'history'

import { FoodAlert } from 'app/foodstuff/components/food-alert'
import { CookieContainer } from 'app/cookie/containers/cookie-container'
import { routes } from 'pages/routes'
import { PATHS } from 'pages/paths'

const history = createBrowserHistory()
const routesName = Object.keys(routes)

const App = () => (
  <Router history={history}>
    <Switch>
      {routesName.map((route) => {
        return <Route key={route} {...routes[route]} />
      })}
      <Redirect from="*" to={PATHS.HOME} />
    </Switch>

    <FoodAlert />
    <CookieContainer />
  </Router>
)

export { App, history }
